import type { PermissionPayload } from '@Application/Security/Roles/Actions/userPermissionsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `byCategory` groups `list` in the server's emission order — categories are never reordered
 * client-side, so the screen renders them exactly as the catalogue endpoint lists them.
 */
class PermissionCatalogView {
	readonly list: readonly PermissionPayload[];
	readonly byCategory: ReadonlyMap<string, readonly PermissionPayload[]>;

	constructor(list: readonly PermissionPayload[]) {
		this.list = list;
		this.byCategory = PermissionCatalogView.groupByCategory(list);

		Object.freeze(this);
	}

	private static groupByCategory(
		list: readonly PermissionPayload[],
	): ReadonlyMap<string, readonly PermissionPayload[]> {
		const grouped = new Map<string, PermissionPayload[]>();

		for (const permission of list) {
			const existingGroup = grouped.get(permission.category);

			if (existingGroup) {
				existingGroup.push(permission);
			} else {
				grouped.set(permission.category, [permission]);
			}
		}

		return grouped;
	}
}

export default PermissionCatalogView;
